/**
 * Компонент кнопки открытия виджета
 */

import { MessageCircle } from 'lucide-react';
import styles from './ChatTriggerButton.module.css';

/**
 * Пропсы компонента ChatTriggerButton
 */
interface ChatTriggerButtonProps {
  /** Колбек при клике на кнопку */
  onClick: () => void;
  /** Показать badge уведомления */
  showBadge?: boolean;
  /** Позиция кнопки */
  position?: 'bottom-right' | 'bottom-left';
  /** Класс для пульсации */
  pulse?: boolean;
}

/**
 * Кнопка триггера виджета чата
 * 
 * @description Плавающая кнопка для открытия виджета чата.
 * Отображается в углу экрана с анимациями.
 */
export function ChatTriggerButton({
  onClick,
  showBadge = false,
  position = 'bottom-right',
  pulse = false,
}: ChatTriggerButtonProps) {
  return (
    <button
      className={`
        ${styles.triggerButton}
        ${position === 'bottom-left' ? styles.positionLeft : ''}
        ${pulse ? styles.pulse : ''}
      `}
      onClick={onClick}
      aria-label="Открыть чат"
      type="button"
    >
      {/* Иконка сообщения */}
      <MessageCircle size={28} strokeWidth={2} className={styles.icon} />

      {/* AI Badge */}
      <span className={styles.aiBadge}>AI</span>

      {/* Badge уведомления */}
      {showBadge && <span className={styles.notificationBadge} aria-label="Новое сообщение" />}
    </button>
  );
}

